import { useContext } from 'react';
import get from 'lodash/get';
import { DataContext, TExtendedSurfaceItem } from 'entries/common/widgets/context';
import { surfacesTypes } from '../const';

export const useSurfaces = (): TExtendedSurfaceItem[] => {
  const data = useContext(DataContext);
  const surfacesData = data!.surfaces.surface;
  return Object.keys(surfacesData).map(surface => {
    const foundedSurface = surfacesTypes.find(surfaceType => surface.toLowerCase() === surfaceType.name);
    const materials = get(surfacesData[surface], 'enums.baseSurface', {}) as {};
    return {
      ...surfacesData[surface],
      name: foundedSurface!.name,
      label: foundedSurface!.label,
      materialLabel: foundedSurface!.materialLabel,
      materials: Object.keys(materials).map(material => ({
        name: material,
        label: material,
      })),
      ...(!!get(surfacesData[surface], 'enums.typeInstallation') && {
        typeInstallation: get(surfacesData[surface], 'enums.typeInstallation'),
      }),
    };
  });
};
